import * as React from 'react'
import styled, { css } from 'styled-components'

import { EmbroideryPreview, untilMd } from '@syconium/little-miss-figgy'

import { EmbroideryService } from '../../../containers/EmbroideryService'

export const EmbroideryModalPreview: React.FC = () => {
  const { backgroundImage, previewItemsByKind, selectedFormKind, currentPlacement } =
    EmbroideryService.useContainer()

  let previewItems: JSX.Element[] = []

  if (selectedFormKind) {
    previewItems = previewItemsByKind[selectedFormKind] ?? []
  } else {
    for (const [_key, value] of Object.entries(previewItemsByKind)) {
      previewItems = [...previewItems, ...value]
    }
  }

  // only show zoomed image on ADD_LOGO screen
  const zoomed = React.useMemo(() => selectedFormKind === 'ADD_LOGO', [selectedFormKind])

  return (
    <Frame>
      <TransformPreview $isActive={zoomed} data-side={currentPlacement?.offsetKey ?? 'right-chest'}>
        <EmbroideryPreview
          previewItems={previewItems}
          backgroundImageSource={backgroundImage?.source}
        />
      </TransformPreview>
    </Frame>
  )
}

const Frame = styled.div`
  position: relative;
  overflow: hidden;
  max-width: 100%;
`

const TransformPreview = styled.div<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive &&
    css`
      ${untilMd} {
        transform-origin: top left;
        transition: transform 150ms ease-out;
      }
      &[data-side='right-chest'] {
        ${untilMd} {
          transform: scale(1.75) translate(0, -10%);
        }
      }
      &[data-side='left-chest'] {
        ${untilMd} {
          transform: scale(1.75) translate(-15%, -10%);
        }
      }
    `}
`
